import React, { useState, useEffect } from 'react';
import {
  Box,
  Breadcrumbs,
  Button,
  CssBaseline,
  Grid,
  IconButton,
  Paper,
  Skeleton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tooltip,
  Typography,
  Dialog,
  TablePagination,
  FormControl,
  Select,
  InputLabel,
  MenuItem,
  FormControlLabel,
  Checkbox,
  DialogTitle,
  Divider,
  DialogContent,
  DialogContentText,
  DialogActions,
  Avatar,
  TextField,
  Stack,
  Pagination,
  CircularProgress,
} from '@mui/material';
import AssignmentIndOutlinedIcon from '@mui/icons-material/AssignmentIndOutlined';
import BlockOutlinedIcon from '@mui/icons-material/BlockOutlined';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import PasswordIcon from '@mui/icons-material/Password';
import CloseIcon from '@mui/icons-material/Close';
import { Container } from '@mui/system';
import { styled } from '@mui/material/styles';
import SwapVertIcon from '@mui/icons-material/SwapVert';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import { useNavigate } from 'react-router-dom';
import NavigateSnackbar from '../navigateSnackbar/NavigateSnackbar';
import inviteUserService from '../../services/inviteUser.service';
import {
  InviteStatus,
  UserPermissionsObject,
  UserRolesOject,
  UserPermission,
  UserRole,
} from '../../utils/constants';
import { IconButtonStyle } from '../Modal/style';
import { useCommonContext } from '../header/context';
import userService from '../../services/user.service';
import InviteDialog from './InviteDialog';
import companyService from '../../services/company.service';
import { projectStyles } from '../header/style';
import ActionModal from '../ActionModal/ActionModal';
import UpdatePassword from './UpdatePassword';
import route from '../../utils/route';
import reportService from '../../services/report.service';
import useMeta from '../../utils/useMeta';
import DynamicForm from '../Filters';
import DateRangeFilter from '../DateRangeFilter';
import { parseDate } from '../dashboard/utils';

const StyledDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiPaper-root': {
    borderRadius: '8px',
    borderBottom: `3px solid ${theme.palette.warning.main}`,
    borderLeft: `3px solid ${theme.palette.warning.main}`,
  },
}));

const StyledTablePagination = styled(TablePagination)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  padding: theme.spacing(2),
  border: '0',
  '& .MuiTablePagination-toolbar': {
    padding: '0',
    width: '100%',
  },
  '& .MuiPagination-root': {
    width: '50%',
  },
  '& .MuiTablePagination-input': {
    border: '1px solid #e3e3e3',
    borderRadius: '4px',
    marginRight: theme.spacing(0),
  },
  '& .MuiTablePagination-selectLabel, & .MuiTablePagination-displayedRows': {
    margin: theme.spacing(0, 2),
  },
  '& .MuiTablePagination-actions': {
    display: 'flex',
    alignItems: 'center',
  },
}));

const CustomPagination = styled(Pagination)(({ theme }) => ({
  '& .MuiPagination-ul': {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    width: 'max-content',
  },
  '& .MuiPaginationItem-root': {
    borderRadius: '8px',
    margin: theme.spacing(0.5),
    padding: '8px 12px',
    border: '1px solid #e0e0e0',
    '&.Mui-selected': {
      backgroundColor: '#1976d2', // Primary color for selected page
      color: '#fff',
      fontWeight: 'bold',
    },
    '&:hover': {
      color: '#000',
      backgroundColor: '#f5f5f5', // Hover effect for buttons
    },
  },
  '& .MuiPaginationItem-ellipsis': {
    border: 'none', // No border for ellipsis
    background: 'none',
  },
  '& .MuiPaginationItem-previousNext': {
    minWidth: '32px', // Ensure uniform size for the previous/next buttons
  },
}));

function InviteUser() {
  useMeta('Invite Users', 'Invite your team members to collaborate on testing projects.');
  const classes = projectStyles();
  const {
    user, setActiveItem, controller, setController,
  } = useCommonContext();
  const navigate = useNavigate();
  const isSuperAdmin = user?.role?.userPermissionsList?.includes(UserPermission.COMPANY);

  const [totalPages, setTotalPages] = useState(1);
  const [invitesData, setInvitesData] = useState(null);
  const [roleList, setRoleList] = useState([]);
  const [companyList, setCompanyList] = useState([]);
  const [projectList, setProjectList] = useState([]);
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [opend, setOpend] = useState(false);

  const [snackbar, setSnackbar] = useState({
    state: false,
    navigateText: '',
    message: '',
    severity: 'success',
  });
  const [open, setOpen] = useState(false);
  const [userDetails, setUserDetails] = useState({});
  const [roleIdForEdit, setRoleIdForEdit] = useState('');
  const [currentRole, setSelectedRole] = useState();
  const [currentStatus, setCurrentStatus] = useState();
  const [eventId, setEventId] = useState();
  const [isBlockUser, setIsBlockUser] = useState(false);
  const [isActiveUser, setIsActiveUser] = useState(false);
  const [currUser, setCurrUser] = useState(false);
  const [openSwitchCompany, setOpenSwitchCompany] = useState(false);
  const [companyIdForSwitch, setCompanyIdForSwitch] = useState('');
  const [projectSwitchId, setProjectSwitchId] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [filterValues, setFilterValues] = useState({});
  const [loading, setLoading] = useState(false);
  const [openPasswordPopup, setOpenPasswordPopup] = useState(false);
  const [updatePasswordRequest, setUpdatePasswordRequest] = useState({});
  const [dateRange, setDateRange] = useState();

  const [formValues, setFormValues] = useState({
    companyId: null,
    firstname: '',
    lastname: '',
    email: '',
  });

  const fields = [
    {
      key: 'firstname',
      type: 'text',
      label: 'First Name',
      value: formValues.firstname,
    },
    {
      key: 'lastname',
      type: 'text',
      label: 'Last Name',
      value: formValues.lastname,
    },
    {
      key: 'email',
      type: 'text',
      label: 'Email',
      value: formValues.email,
    },
    user?.role?.roleName === UserRole.SUPER_ADMIN
    && {
      key: 'companyId',
      type: 'dropdown',
      label: 'Company',
      value: formValues.companyId,
      options: companyList && companyList?.map((company) => ({
        value: company.companyId,
        label: company.companyName,
      })),
    },
  ];

  const handleApply = (range) => {
    setDateRange(range);
  };

  const handleFieldChange = (fieldKey, value) => {
    setFormValues((prev) => ({ ...prev, [fieldKey]: value }));
  };

  const handleSubmit = () => {
    setFilterValues(formValues);
  };

  const handleClear = () => {
    setFormValues({
      companyId: null,
      firstname: '',
      lastname: '',
      email: '',
    });
    setFilterValues({});
  };
  const getRoleDetailsForEdit = (id) => {
    const result = roleList.find((i) => i.roleId === id);
    setSelectedRole(result);
  };

  const generateQuery = (filterParams = {}) => {
    const timestring = 'createAt';
    let filterAnd = '';
    if (dateRange) {
      filterAnd = `${timestring}|gte|${dateRange.startDate}&${timestring}|lte|${dateRange.endDate}`;
    }
    const appendFilter = (condition) => {
      if (filterAnd) {
        filterAnd += `&${condition}`;
      } else {
        filterAnd += condition;
      }
    };

    if (filterParams.companyId) {
      appendFilter(`companyId|eq|${filterParams.companyId}`);
    }

    if (filterParams.firstname) {
      appendFilter(`firstName|lic|${filterParams.firstname}`);
    }
    if (filterParams.lastname) {
      appendFilter(`lastName|lic|${filterParams.lastname}`);
    }
    if (filterParams.email) {
      appendFilter(`email|lic|${filterParams.email}`);
    }

    const params = {
      pageNumber: `${controller.page - 1}`,
      pageSize: `${controller.rowsPerPage}`,
      orders: `${timestring}|desc`,
      filterAnd,
    };
    return new URLSearchParams(params).toString();
  };

  const handleSetPassword = async (newPassword) => {
    try {
      const resetRequest = {
        email: updatePasswordRequest?.email,
        newPassword,
        status: updatePasswordRequest?.status,
      };
      await userService.changePasswordBySuperAdmin(resetRequest);
      setSnackbar({
        navigateText: '',
        severity: 'success',
        state: true,
        message: 'User Password Updated Successfully.',
      });
      setUpdatePasswordRequest({});
      setOpenPasswordPopup(false);
    } catch (err) {
      if (err) {
        setSnackbar({
          navigateText: '',
          severity: 'error',
          state: true,
          message: `${err.data.message}`,
        });
      }
    }
  };

  const invitedUsers = async () => {
    try {
      setLoading(true);
      const query = generateQuery(filterValues);
      const response = await inviteUserService.getAllInvitedUser(query);
      if (response) {
        setInvitesData(response.content);
        setTotalPages(response?.totalPages);
      }
    } catch (error) {
      setInvitesData([]);
      setSnackbar({
        navigateText: '',
        severity: 'error',
        state: true,
        message: `${error?.data?.message}`,
      });
    } finally {
      setLoading(false);
    }
  };

  const handleRoleChange = (event) => {
    setRoleIdForEdit(event.target.value);
    getRoleDetailsForEdit(event.target.value);
  };

  const handleCompanyChange = (event) => {
    setCompanyIdForSwitch(event.target.value);
    setProjectSwitchId('');
  };

  const onClose = () => {
    setOpen(false);
  };

  const handleOpen = async (uEmail) => {
    try {
      const res = await userService.getUserByEmail(uEmail);
      setUserDetails(res);
      setSelectedRole(res?.role);
      setRoleIdForEdit(res?.role?.roleId);
      setOpen(true);
    } catch (error) {
      setSnackbar({
        navigateText: '',
        severity: 'error',
        state: true,
        message: `${error?.message}`,
      });
    }
  };

  const handleSwitchCompanyOpen = async (userEmail) => {
    try {
      const res = await userService.getUserByEmail(userEmail);
      setCurrUser(res);
      setCompanyIdForSwitch(res?.company?.companyId);
      setOpenSwitchCompany(true);
    } catch (error) {
      setSnackbar({
        navigateText: '',
        severity: 'error',
        state: true,
        message: `${error?.message}`,
      });
    }
  };

  const handlePasswordChangeOpen = async (userEmail, inviteStatus) => {
    setUpdatePasswordRequest({ email: userEmail, status: inviteStatus });
    setOpenPasswordPopup(true);
  };

  const closeSwitchCompany = () => {
    setOpenSwitchCompany(false);
  };

  const fetchRoleList = async () => {
    try {
      const res = await userService.getAllRole();
      setRoleList(res);
    } catch (error) {
      setRoleList([]);
    }
  };

  const fetchCompanyList = async () => {
    try {
      const res = await companyService.getAll();
      setCompanyList(res);
    } catch (error) {
      setCompanyList([]);
    }
  };

  const fetchProjectList = async () => {
    try {
      setIsLoading(true);
      const res = await reportService.getProjectById(companyIdForSwitch);
      setProjectList(res);
    } catch (error) {
      setProjectList([]);
    } finally {
      setIsLoading(false);
    }
  };
  const onSubmit = async (e) => {
    e.preventDefault();
    const rolePayload = {
      email: userDetails?.email,
      roleId: roleIdForEdit,
    };
    try {
      await userService.userUpdateRole(rolePayload);
      invitedUsers();
      fetchRoleList();
    } catch (error) {
      setSnackbar({
        navigateText: '',
        severity: 'error',
        state: true,
        message: error?.data?.message,
      });
    } finally {
      onClose();
    }
  };

  const handleChangePage = (event, newPage) => {
    setController({ ...controller, page: newPage });
  };

  const handleChangeRowsPerPage = (event) => {
    setController({ rowsPerPage: parseInt(event.target.value, 10), page: 1 });
  };

  const onSubmitCompany = async (e) => {
    e.preventDefault();
    const rolePayload = {
      userId: currUser?.id,
      companyId: companyIdForSwitch,
      projectId: projectSwitchId,
    };
    try {
      const response = await userService.userSwitchCompany(rolePayload);
      invitedUsers();
      setSnackbar({
        navigateText: '',
        severity: 'success',
        state: true,
        message: response,
      });
    } catch (error) {
      setSnackbar({
        navigateText: '',
        severity: 'error',
        state: true,
        message: error?.data?.message,
      });
    } finally {
      closeSwitchCompany();
    }
  };

  const blockUser = async (item) => {
    setOpend(true);
    setEventId(item);
    setIsBlockUser(item.inviteStatus === InviteStatus.ACCEPT
      || item.inviteStatus === InviteStatus.ACTIVE);
    setIsActiveUser(item.inviteStatus === InviteStatus.EXPIRED
      || item.inviteStatus === InviteStatus.BLOCK
      || item.inviteStatus === InviteStatus.BLOCKED
      || item.inviteStatus === InviteStatus.PENDING);
    setCurrentStatus(item.inviteStatus === InviteStatus.ACCEPT
      ? InviteStatus.BLOCK : InviteStatus.ACCEPT);
  };
  const onHandleBlock = async () => {
    if (eventId) {
      const payload = {
        email: eventId.email,
        status: eventId.inviteStatus === InviteStatus.ACCEPT
          ? InviteStatus.BLOCKED : InviteStatus.ACCEPT,
      };
      try {
        // setLoading(true);
        const response = await inviteUserService.updateStatus(payload);
        invitedUsers();
        setSnackbar({
          navigateText: '',
          severity: 'success',
          state: true,
          message: `${response}`,
        });
        setOpend(false);
      } catch (error) {
        setSnackbar({
          navigateText: '',
          severity: 'error',
          state: true,
          message: `${error.message}`,
        });
        setOpend(false);
      } finally {
        setOpend(false);
      }
    }
  };

  useEffect(() => {
    invitedUsers();
  }, [controller, filterValues, dateRange]);

  useEffect(() => {
    fetchRoleList();
  }, []);

  useEffect(() => {
    if (openSwitchCompany) {
      fetchCompanyList();
    }
  }, [openSwitchCompany]);

  const handleClose = () => {
    setOpend(false);
    setIsBlockUser(false);
    setIsActiveUser(false);
  };

  useEffect(() => {
    setActiveItem('User');
    fetchCompanyList();
  }, []);

  useEffect(() => {
    if (companyIdForSwitch) {
      fetchProjectList();
    }
  }, [companyIdForSwitch]);

  return (
    <Container maxWidth={false} className={classes.root}>
      <CssBaseline />
      <Breadcrumbs separator={<NavigateNextIcon fontSize="small" />} aria-label="breadcrumb" marginBottom={2}>
        <Typography color="#666666" onClick={() => navigate(`/${route.ROUTE_DASHBOARD}`)} sx={{ cursor: 'pointer' }}>Dashboard</Typography>
        <Typography color="#666666">Users</Typography>
      </Breadcrumbs>
      <Box className={classes.heading}>
        <Typography className={classes.title} variant="h4">
          Users
        </Typography>
      </Box>
      <Grid container spacing={2}>
        <Grid item xs={12} mt={4}>
          <Paper className={classes.summaryBox}>
            <Box className={classes.summaryBoxInTeam}>
              <Grid item xs={12}>
                <Grid sx={{
                  py: 2,
                  px: 1.5,
                }}
                >
                  {user?.role?.roleName === UserRole.SUPER_ADMIN && <DateRangeFilter
                    initialDateRange={dateRange}
                    onApply={handleApply}
                  />}
                </Grid>
                <Grid
                  display="flex"
                  justifyContent="flex-start"
                  alignItems="center"
                  sx={{
                    py: 2,
                    px: 1.5,
                    borderBottom: '1px solid #e2e5e8',
                  }}
                >
                  <DynamicForm
                    fields={fields}
                    onChange={handleFieldChange}
                    onSubmit={handleSubmit}
                    onClear={handleClear}
                  />
                </Grid>
              </Grid>
              <TableContainer component={Paper} className={classes.tableContainer}>
                {user?.role?.userPermissionsList.includes(UserPermission.INVITE_USER)
                  ? <Table>
                    <TableHead>
                      <TableRow>
                        <TableCell className={classes.headerCell} />
                        <TableCell className={classes.headerCell}>Name</TableCell>
                        <TableCell className={classes.headerCell}>Email</TableCell>
                        <TableCell className={classes.headerCell}>Company</TableCell>
                        <TableCell className={classes.headerCell}>Role</TableCell>
                        <TableCell className={classes.headerCell}>Created At</TableCell>
                        <TableCell className={classes.headerCell}>Status</TableCell>
                        {user?.role?.userPermissionsList.includes(UserPermission.INVITE_USER)
                          && <TableCell className={classes.headerCell}>Actions</TableCell>}
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {loading ? <>
                        <TableRow>
                          <TableCell><Skeleton animation="wave" /></TableCell>
                          <TableCell><Skeleton animation="wave" /></TableCell>
                          <TableCell><Skeleton animation="wave" /></TableCell>
                          <TableCell><Skeleton animation="wave" /></TableCell>
                          <TableCell><Skeleton animation="wave" /></TableCell>
                          <TableCell><Skeleton animation="wave" /></TableCell>
                          <TableCell><Skeleton animation="wave" /></TableCell>
                          <TableCell><Skeleton animation="wave" /></TableCell>
                        </TableRow>
                      </> : <>
                        {invitesData?.length ? (invitesData?.map((row) => (
                          <TableRow key={row?.projectId}>
                            <TableCell>
                              <Avatar src={row.image} />
                            </TableCell>
                            <TableCell>
                              <Typography variant="body1">{`${row?.firstName} ${row?.lastName}`}</Typography>
                            </TableCell>
                            <TableCell>
                              <Typography variant="body1">{row?.email}</Typography>
                            </TableCell>
                            <TableCell>{row?.company?.companyName}</TableCell>
                            <TableCell>{UserRolesOject[row?.role?.roleName]}</TableCell>
                            <TableCell>{parseDate(row?.createAt)}</TableCell>
                            <TableCell>{row?.inviteStatus}</TableCell>
                            {user?.role?.userPermissionsList.includes(UserPermission.INVITE_USER)
                              && <TableCell>
                                <Box display="flex" justifyContent="flex-start">
                                  <Tooltip title="Assign Permission">
                                    <IconButton
                                      style={{ color: '#1D6AE5' }}
                                      onClick={() => {
                                        handleOpen(row.email);
                                      }}
                                      disabled={row.inviteStatus === InviteStatus.PENDING
                                        || row.inviteStatus === InviteStatus.BLOCKED}
                                    >
                                      <AssignmentIndOutlinedIcon />
                                    </IconButton>
                                  </Tooltip>
                                  <Tooltip title={row.inviteStatus === InviteStatus.ACCEPT
                                    ? 'Block' : 'Unblock'}
                                  >
                                    <IconButton
                                      style={{ color: '#FFC72B' }}
                                      onClick={() => blockUser(row)}
                                    >
                                      {
                                        row.inviteStatus === InviteStatus.ACCEPT
                                          ? <BlockOutlinedIcon color="error" /> : <CheckCircleOutlineIcon color="success" />
                                      }
                                    </IconButton>
                                  </Tooltip>
                                  {(isSuperAdmin && UserRolesOject[row?.role?.roleName] !== UserRole.ADMIN) && <Tooltip title="Switch Company">
                                    <IconButton
                                      style={{ color: '#1D6AE5' }}
                                      onClick={() => {
                                        handleSwitchCompanyOpen(row.email);
                                      }}
                                      disabled={row.inviteStatus === InviteStatus.PENDING
                                        || row.inviteStatus === InviteStatus.BLOCKED}
                                    >
                                      <SwapVertIcon />
                                    </IconButton>
                                  </Tooltip>}
                                  {user?.role?.roleName === UserRole.SUPER_ADMIN && <Tooltip title="Update Password">
                                    <IconButton
                                      style={{ color: '#1D6AE5' }}
                                      onClick={() => {
                                        handlePasswordChangeOpen(row.email, row.inviteStatus);
                                      }}
                                      disabled={row.inviteStatus === InviteStatus.EXPIRED
                                        || row.inviteStatus === InviteStatus.BLOCK
                                        || row.inviteStatus === InviteStatus.BLOCKED
                                        || row.inviteStatus === InviteStatus.PENDING}
                                    >
                                      <PasswordIcon />
                                    </IconButton>
                                  </Tooltip>}
                                </Box>
                              </TableCell>}
                          </TableRow>))) : (
                            <TableRow>
                              <TableCell colSpan={7} align="center">
                                <Typography variant="body2" color="textSecondary">
                                  No user found.
                                </Typography>
                              </TableCell>
                            </TableRow>
                        )}
                      </>}
                      <StyledDialog
                        open={open}
                        onClose={onClose}
                      >
                        <DialogTitle>
                          Grant Permissions
                        </DialogTitle>
                        <Divider />
                        <IconButtonStyle
                          aria-label="close"
                          data-testid="UploadReport-box"
                          onClick={onClose}
                        >
                          <CloseIcon />
                        </IconButtonStyle>
                        <form onSubmit={(e) => onSubmit(e)}>
                          <DialogContent>
                            <DialogTitle sx={{ px: '0', pb: 1, mb: 0 }}>
                              {`${userDetails.firstName} ${userDetails.lastName}`}
                            </DialogTitle>
                            <DialogContentText sx={{ mb: 3, px: '0', mr: '0' }}>
                              {userDetails.email}
                            </DialogContentText>
                            <FormControl fullWidth>
                              <InputLabel>Permissions</InputLabel>
                              {userDetails && Object.keys(userDetails).length > 0
                                && <Select
                                  fullWidth
                                  value={roleIdForEdit}
                                  onChange={handleRoleChange}
                                  label="Permissions"
                                >
                                  {roleList && roleList?.map((role) => (
                                    <MenuItem value={role?.roleId} key={role?.roleId}>
                                      {role?.roleName}
                                    </MenuItem>
                                  ))}
                                </Select>}
                            </FormControl>
                            <Grid container sx={{ mt: 2 }}>
                              <Grid item lg={3} xs={12}>
                                <FormControlLabel control={<Checkbox name="VIEW_REPORT" checked={Boolean(currentRole?.userPermissionsList?.includes('VIEW_REPORT'))} />} label={UserPermissionsObject.VIEW_REPORT} />
                                <FormControlLabel control={<Checkbox name="UPLOAD_REPORT" checked={Boolean(currentRole?.userPermissionsList?.includes('UPLOAD_REPORT'))} />} label={UserPermissionsObject.UPLOAD_REPORT} />
                                <FormControlLabel control={<Checkbox name="INVITE_USER" checked={Boolean(currentRole?.userPermissionsList?.includes('INVITE_USER'))} />} label={UserPermissionsObject.INVITE_USER} />
                              </Grid>
                              <Grid item lg={3} xs={12}>
                                <FormControlLabel control={<Checkbox name="ROLE" checked={Boolean(currentRole?.userPermissionsList?.includes('ROLE'))} />} label={UserPermissionsObject.ROLE} />
                                <FormControlLabel control={<Checkbox name="COMPANY" checked={Boolean(currentRole?.userPermissionsList?.includes('COMPANY'))} />} label={UserPermissionsObject.COMPANY} />
                                <FormControlLabel control={<Checkbox name="PROJECT" checked={Boolean(currentRole?.userPermissionsList?.includes('PROJECT'))} />} label={UserPermissionsObject.PROJECT} />
                              </Grid>
                              <Grid item lg={3} xs={12}>
                                <FormControlLabel control={<Checkbox name="INVITE_PROJECT" checked={Boolean(currentRole?.userPermissionsList?.includes('INVITE_PROJECT'))} />} label={UserPermissionsObject.INVITE_PROJECT} />
                                <FormControlLabel control={<Checkbox name="MAVEN_PLUGIN" checked={Boolean(currentRole?.userPermissionsList?.includes('MAVEN_PLUGIN'))} />} label={UserPermissionsObject.MAVEN_PLUGIN} />
                                <FormControlLabel control={<Checkbox name="GUEST_USER" checked={Boolean(currentRole?.userPermissionsList?.includes('GUEST_USER'))} />} label={UserPermissionsObject.GUEST_USER} />
                              </Grid>
                              <Grid item lg={3} xs={12}>
                                <FormControlLabel control={<Checkbox name="TEAM" checked={Boolean(currentRole?.userPermissionsList?.includes('TEAM'))} />} label={UserPermissionsObject.TEAM} />
                                <FormControlLabel control={<Checkbox name="INVITE_REPORT" checked={Boolean(currentRole?.userPermissionsList?.includes('INVITE_REPORT'))} />} label={UserPermissionsObject.INVITE_REPORT} />
                                <FormControlLabel control={<Checkbox name="SLACK_INTEGRATION" checked={Boolean(currentRole?.userPermissionsList?.includes('SLACK_INTEGRATION'))} />} label={UserPermissionsObject.SLACK_INTEGRATION} />
                              </Grid>
                              <Grid item lg={3} xs={12}>
                                <FormControlLabel control={<Checkbox name="JIRA_INTEGRATION" checked={Boolean(currentRole?.userPermissionsList?.includes('JIRA_INTEGRATION'))} />} label={UserPermissionsObject.JIRA_INTEGRATION} />
                              </Grid>
                            </Grid>
                          </DialogContent>
                          <Divider />
                          <DialogActions>
                            <Button type="submit" autoFocus color="primary" variant="contained">
                              Submit
                            </Button>
                            <Button autoFocus color="primary" variant="text" onClick={onClose}>
                              Cancel
                            </Button>
                          </DialogActions>
                        </form>
                      </StyledDialog>
                      <StyledDialog
                        open={openSwitchCompany}
                        onClose={closeSwitchCompany}
                      >
                        <DialogTitle>
                          Switch Company
                        </DialogTitle>
                        <Divider />
                        <IconButtonStyle
                          onClick={closeSwitchCompany}
                        >
                          <CloseIcon />
                        </IconButtonStyle>
                        <form onSubmit={(e) => onSubmitCompany(e)}>
                          <DialogContent>
                            <Stack sx={{ minWidth: '480px' }}>
                              <DialogTitle sx={{ p: '0px', mb: '10px' }}>
                                {`${currUser?.firstName} ${currUser?.lastName}`}
                              </DialogTitle>
                              <DialogContentText sx={{ mb: '24px' }}>
                                {currUser?.email}
                              </DialogContentText>
                              <TextField
                                label="Current Company"
                                InputProps={{
                                  readOnly: true,
                                }}
                                sx={{ mb: '24px' }}
                                value={currUser?.company?.companyName}
                              />
                              <FormControl sx={{ mb: '24px' }}>
                                <InputLabel>Switch Company</InputLabel>
                                <Select
                                  value={companyIdForSwitch}
                                  onChange={handleCompanyChange}
                                  label="Switch Company"
                                >
                                  {companyList && companyList?.map((comp) => (
                                    <MenuItem value={comp?.companyId} key={comp?.companyId}>
                                      {comp?.companyName}
                                    </MenuItem>
                                  ))}
                                </Select>
                              </FormControl>
                              <FormControl sx={{ mb: '10px' }}>
                                <InputLabel>Select Project</InputLabel>
                                <Select
                                  value={projectSwitchId !== ''
                                    ? projectSwitchId : projectList[0]?.projectId}
                                  onChange={(e) => setProjectSwitchId(e.target.value)}
                                  label="Select Project"
                                  displayEmpty
                                  IconComponent={isLoading
                                    ? () => <CircularProgress size={18} sx={{ mx: 1 }} />
                                    : undefined}
                                >
                                  {projectList.length > 0 ? (
                                    projectList.map((proj) => (
                                      <MenuItem value={proj?.projectId} key={proj?.projectId}>
                                        {proj?.projectName}
                                      </MenuItem>
                                    ))
                                  ) : (
                                    <MenuItem value="" disabled>
                                      No Projects Available
                                    </MenuItem>
                                  )}
                                </Select>
                              </FormControl>
                            </Stack>
                          </DialogContent>
                          <Divider />
                          <DialogActions>
                            <Button type="submit" autoFocus color="primary" variant="contained">
                              Submit
                            </Button>
                            <Button autoFocus color="primary" variant="text" onClick={closeSwitchCompany}>
                              Cancel
                            </Button>
                          </DialogActions>
                        </form>
                      </StyledDialog>
                      {openPasswordPopup && <UpdatePassword
                        onSetPassword={handleSetPassword}
                        setOpenPasswordPopup={setOpenPasswordPopup}
                        openPasswordPopup={openPasswordPopup}
                        setUpdatePasswordRequest={setUpdatePasswordRequest}
                      />}
                    </TableBody>
                  </Table>
                  : <Table>
                    <TableHead>
                      <TableRow>
                        <TableCell className={classes.headerCell} />
                        <TableCell className={classes.headerCell}>Name</TableCell>
                        <TableCell className={classes.headerCell}>Email</TableCell>
                        <TableCell className={classes.headerCell}>Company</TableCell>
                        <TableCell className={classes.headerCell}>Role</TableCell>
                        <TableCell className={classes.headerCell}>Status</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {invitesData && invitesData?.length ? invitesData?.map((row) => (
                        <TableRow key={row?.projectId}>
                          <TableCell>
                            <Avatar src={row.image} />
                          </TableCell>
                          <TableCell>
                            <Typography variant="body1">{`${row?.firstName} ${row?.lastName}`}</Typography>
                          </TableCell>
                          <TableCell>
                            <Typography variant="body1">{row?.email}</Typography>
                          </TableCell>
                          <TableCell>{row?.company?.companyName}</TableCell>
                          <TableCell>{UserRolesOject[row?.role?.roleName]}</TableCell>
                          <TableCell>{row?.inviteStatus}</TableCell>
                        </TableRow>
                      )) : <TableRow>
                        <TableCell><Skeleton animation="wave" /></TableCell>
                        <TableCell><Skeleton animation="wave" /></TableCell>
                        <TableCell><Skeleton animation="wave" /></TableCell>
                        <TableCell><Skeleton animation="wave" /></TableCell>
                      </TableRow>}
                    </TableBody>
                  </Table>}
                {totalPages > 0 ? (
                  <Box className={classes.paginationContainer}>
                    <StyledTablePagination
                      count={totalPages * controller.rowsPerPage}
                      totalPages={totalPages}
                      page={controller.page - 1}
                      onPageChange={handleChangePage}
                      ActionsComponent={() => <CustomPagination
                        count={totalPages}
                        page={controller.page}
                        onChange={handleChangePage}
                        variant="outlined"
                        shape="rounded"
                        showFirstButton
                        showLastButton
                      />}
                      rowsPerPage={controller.rowsPerPage}
                      rowsPerPageOptions={[5, 10, 15, 20, 25, 50]}
                      onRowsPerPageChange={handleChangeRowsPerPage}
                    />
                  </Box>
                ) : <></>}
              </TableContainer>
              {!loading && invitesData === null
                && <Typography textAlign="center" variant="subtitle1" color="textSecondary">
                  No user Found
                </Typography>}
            </Box>
          </Paper>
        </Grid>
      </Grid>
      {opend && (
        <ActionModal
          handleClose={handleClose}
          opend={opend}
          action={currentStatus}
          handleAction={() => onHandleBlock()}
          isBlock={isBlockUser}
          isActive={isActiveUser}
          page="user"
        />
      )}
      <InviteDialog
        isOpen={isDialogOpen}
        roleList={roleList}
        onClose={() => setIsDialogOpen(false)}
        onSuccess={
          () => {
            invitedUsers(filterValues);
            setIsDialogOpen(false);
          }
        }
        setSnackbar={setSnackbar}
      />
      {
        snackbar.state
        && (
          <NavigateSnackbar
            snackbarObj={snackbar}
            setSnackbar={setSnackbar}
          />
        )
      }
    </Container>
  );
}

export default InviteUser;
